/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Gotohomepage2Inputs */

const en_btn_gotohomepage2 = /** @type {(inputs: Btn_Gotohomepage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Return to homepage`)
};

/**
* | output |
* | --- |
* | "Return to homepage" |
*
* @param {Btn_Gotohomepage2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const btn_gotohomepage2 = /** @type {((inputs?: Btn_Gotohomepage2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Gotohomepage2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_gotohomepage2(inputs)
});
export { btn_gotohomepage2 as "btn_goToHomepage" }